import { useUploadImageMutation } from '@/editor/services/http/media-library.api';
import { dataURLtoBlob, getImageDimensions } from '../services/imageUtilities';
import { useCallback } from 'react';

export const useCroppedGoogleImages = (imageData: Record<number, string>, propertyInternalId: string) => {
  const [uploadImage, { isLoading }] = useUploadImageMutation();

  const uploadImages = useCallback(async (): Promise<Record<'square' | 'landscape', string>> => {
    const uploadPromises = Object.entries(imageData).map(async ([ratioStr, dataUrl]) => {
      try {
        const blob = await dataURLtoBlob(dataUrl);

        const { width, height } = await getImageDimensions(dataUrl);

        const extension = blob.type.split('/')[1] || 'jpg';

        const result = await uploadImage({
          propertyId: propertyInternalId,
          extension,
          width,
          height,
          file: blob,
        }).unwrap();

        return { ratio: parseFloat(ratioStr), success: true, data: result.propertyFileId };
      } catch (error) {
        console.error(`Failed to upload image for ratio ${ratioStr}:`, error);
        return { ratio: parseFloat(ratioStr), success: false, error };
      }
    });

    const results = await Promise.all(uploadPromises);

    const mappedResponse = results.reduce(
      (accumulator, currentResult) => {
        if (currentResult.success) {
          const key = currentResult.ratio === 1 ? 'square' : 'landscape';
          // TODO: Handle additional aspect ratios if needed
          accumulator[key] = currentResult.data as string;
        }

        return accumulator;
      },
      {} as Record<'square' | 'landscape', string>
    );

    return mappedResponse;
  }, [imageData, uploadImage]);

  return { uploadImages, isLoading };
};
